import { getPortPoints, type PortAddress } from '#app/utils/farm-map.ts'

export const addressLabelKey = (
	port: Pick<PortAddress, 'ditch' | 'entry' | 'position' | 'address'>,
) => `${port.ditch}-${port.entry}-${port.position}-${port.address}`

/** Renders each port's house number next to its spot along the ditch, like the paper map. */
export function AddressLabels({
	ports,
	visitedAddresses,
	scheduledAddresses,
	hoursByAddress,
}: {
	ports: PortAddress[]
	visitedAddresses?: ReadonlySet<string>
	scheduledAddresses?: ReadonlySet<string>
	hoursByAddress?: ReadonlyMap<string, number>
}) {
	const points = getPortPoints(ports).filter((port) => port.address)

	return (
		<g>
			{points.map((port, i) => {
				const onDitch9 = port.ditch === 9
				const key = addressLabelKey(port)
				const visited = visitedAddresses?.has(key)
				const scheduled = scheduledAddresses?.has(key)
				const hours = hoursByAddress?.get(key)
				const hoursLabel = hours ? `${hours}h` : null
				const labelOnLeft = !onDitch9 && port.direction === '<'
				const labelX = onDitch9 ? port.x : port.x + (labelOnLeft ? -8 : 8)
				const labelY = onDitch9
					? port.y + (port.direction === '^' ? -10 : 16)
					: port.y + 3
				const textAnchor = onDitch9 ? 'middle' : labelOnLeft ? 'end' : 'start'
				const boxX = onDitch9
					? labelX - 15
					: labelOnLeft
						? labelX - 28
						: labelX - 2
				// place the hours just past whichever edge of the box faces "outward"
				const hoursAnchor = labelOnLeft ? 'end' : 'start'
				const hoursX = labelOnLeft ? boxX - 3 : boxX + 30 + 3
				return (
					<g key={`address-${port.ditch}-${port.entry}-${port.position}-${i}`}>
						<rect
							x={boxX}
							y={labelY - 9}
							width={30}
							height={12}
							className={`${visited ? 'fill-sky-200' : 'fill-white'} ${scheduled ? 'stroke-sky-200' : 'stroke-transparent'}`}
							strokeWidth={scheduled ? 1.5 : 0}
						/>
						<text
							x={labelX}
							y={labelY}
							textAnchor={textAnchor}
							className="fill-muted-foreground text-[8px]"
						>
							{port.address}
						</text>
						{hoursLabel ? (
							<text
								x={hoursX}
								y={labelY}
								textAnchor={hoursAnchor}
								className="fill-sky-700 text-[7px] font-medium"
							>
								{hoursLabel}
							</text>
						) : null}
					</g>
				)
			})}
		</g>
	)
}
